export { AmpAccordion } from './Accordion/AmpAccordion'
export { AmpCarousel } from './Carousel/AmpCarousel'
export { AmpLayout } from './Layout/AmpLayout'
export { AmpSidebar } from './Sidebar/AmpSidebar'

export type AmpLayoutType =
  | 'fill'
  | 'fixed'
  | 'fixed-height'
  | 'flex-item'
  | 'intrinsic'
  | 'nodisplay'
  | 'responsive'

export interface AmpImgType {
  alt?: string
  src?: string
  width?: number
  height?: number
  layout?: AmpLayoutType
}
